/**
 * Defines newsgroup types on which user can custom filter
 */
export var GroupFilterValues;
(function (GroupFilterValues) {
    GroupFilterValues["athlitikes"] = "athlitikes";
    GroupFilterValues["politikes"] = "politikes";
})(GroupFilterValues || (GroupFilterValues = {}));
